module.exports = __webpack_public_path__ + "img/athlete-platzhalter@2x.a451af78.jpg";